"use client";

import styles from "./career-place.module.scss";
import Image from "next/image";
import React from "react";
import { parseHtml, toWebp } from "@/utils/common";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

import "@splidejs/react-splide/css"; // Splide base styles

interface Props {
  data?: any;
}
const CareerPlace = ({ data }: Props) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";

  return (
    <>
      <section className="great-place bg-white py-[56px] md:py-[80px] xl:py-[100px] ">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-[calc(60%-8px)_calc(40%-8px)] lg:grid-cols-[calc(60%-15px)_calc(40%-15px)] xl:grid-cols-[calc(70%-25px)_calc(30%-25px)] gap-[16px] lg:gap-[30px] xl:gap-[50px]">
            <div className="left">
              <h2
                className={`mb-[12px] font-bold text-primary-text text-heading-1 md:text-left text-center ${styles["headingCareer"]}`}
              >
                {parseHtml(data?.title)}
              </h2>
              <p className="text-[#32343B] text-[20px] leading-[28px] xl:text-[24px] xl:leading-[31.2px] font-[400] mb-[24px] md:text-left text-center">
                {data?.description}
              </p>
              <p className="text-[#32343B] text-[20px] leading-[28px] xl:text-[24px] xl:leading-[31.2px] font-[400] mb-[24px] md:text-left text-center">
                {data?.description_2}
              </p>
            </div>
            <div className="right">
              <div
                className="great-card border-[#B0D9F7] border-[0.9px] p-[58px] group
              relative z-10 before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-[url('/images/career-card-shape-t.png')] before:bg-center before:bg-no-repeat before:bg-cover before:z-[-1]
            after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:bg-[url('/images/career-card-shape-b.png')] after:bg-center after:bg-no-repeat after:bg-cover after:z-[-1]
              "
              >
                <div className="shape absolute top-0 left-0 w-full z-[-1]">
                  <Image
                    src={toWebp("/images/career-shape-icn.svg")}
                    alt="great-place"
                    width={696}
                    height={283}
                    className="w-full h-full object-cover"
                  />
                </div>
                {data?.right_image?.data?.attributes?.url && (
                  <Image
                    src={toWebp(
                      baseUrl + data?.right_image?.data?.attributes?.url,
                    )}
                    alt="great-place"
                    width={140}
                    height={235}
                    className="max-w-[100px] xl:max-w-[140px] h-auto object-cover mx-auto group-hover:scale-[1.1] group-focus-within:scale-100 transition-all duration-300 scale-100 ease-in-out"
                  />
                )}
              </div>
              <div className="bg-white border-[#B0D9F7] border-[0.9px] border-t-0 p-[24px_16px] space-y-6">
                <h3 className="text-[#040405] xl:text-[32px] xl:leading-[41.6px] md:text-[24px] md:leading-[31.2px] text-[22px] leading-[28.6px] font-[700] mb-[20px]">
                  {data?.right_title}
                </h3>
                <div
                  className={`px-[5px] font-[400] xl:text-[24px] xl:leading-[31.2px] text-[20px] leading-[26px] text-[#32343B] ${styles["excited"]}`}
                >
                  {parseHtml(data?.right_description)}
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-[30px] pt-[56px] md:pt-[80px] xl:pt-[100px]">
            {data.stats.map((stat: any, index: number) => (
              <div
                key={"start" + index + "stat"}
                className={`group relative pb-[140px] bg-white border border-[#${index === 1 ? "DBEAB0" : "B0D9F7"}] overflow-hidden before:bg-[url(${index === 1 ? "/images/career-yellow-shape-b.png" : "/images/career-blue-shape-b.png"})] before:bg-center before:bg-no-repeat before:bg-cover before:content-[''] before:absolute before:bottom-0 before:left-0 before:w-full before:h-full before:z-[1]  ${styles["career-stats-card" + (index === 1 ? "-1" : "")]}`}
              >
                {index === 1 && (
                  <div className="absolute top-[50px] left-0 w-full z-[2]">
                    <Image
                      src={
                        index === 1
                          ? "/images/career-map.svg"
                          : "/images/career-blue-shape-b.png"
                      }
                      alt="great-place"
                      width={391}
                      height={192}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <h4 className="mt-[32px] font-bold text-center xl:text-[64px] xl:leading-[83.2px] md:text-[48px] md:leading-[62.2px] text-[32px] leading-[41.6px] relative z-10">
                  {stat?.title}
                </h4>
                <p className="lg:text-[16px] lg:leading-[22.4px] text-[14px] leading-[19.6px] font-bold text-center relative z-10">
                  {stat?.short_title}
                </p>
                {index === 0 ? (
                  <div
                    className={`absolute left-0 w-full z-[0] group-hover:transform group-hover:-translate-y-[10px] transition-all duration-300 ease-in-out ${styles.bannerImageWrapper}`}
                  >
                    {stat?.statistics[0]?.image?.data?.attributes?.url && (
                      <Image
                        src={toWebp(
                          `${baseUrl}${stat?.statistics[0]?.image?.data?.attributes?.url}`,
                        )}
                        alt="team"
                        width={358 * 2}
                        height={212 * 2}
                        quality={100}
                        className="object-cover grayscale "
                      />
                    )}
                  </div>
                ) : index === 1 ? (
                  <div className="w-full overflow-hidden absolute bottom-[24px] z-[10]">
                    <div className="mb-[16px]">
                      <Splide
                        options={{
                          type: "loop",
                          drag: "free", // keep "free" here for smooth marquee-like effect
                          focus: "center",
                          arrows: false,
                          pagination: false,
                          autoWidth: true,
                          gap: "8px",
                          autoScroll: {
                            speed: 1, // try values between 0.5 - 2 for smoothness
                            pauseOnHover: true,
                            pauseOnFocus: false,
                          },
                        }}
                        extensions={{ AutoScroll }}
                        className="marquee-splide"
                      >
                        {stat.statistics.map((item: any, index: number) => (
                          <SplideSlide key={"statistics-" + index}>
                            <div
                              key={"statistics" + index}
                              className="p-[8px_12px] bg-white border border-[#DBEAB0] flex items-center w-fit"
                            >
                              {item?.image?.data?.attributes?.url && (
                                <Image
                                  src={toWebp(
                                    `${baseUrl}${item?.image?.data?.attributes?.url}`,
                                  )}
                                  alt="flag"
                                  width={16}
                                  height={16}
                                  className="w-[16px] h-[16px] object-cover"
                                />
                              )}
                              <p className="text-[#32343B] text-[12px] ml-[8px]">
                                {item.title}
                              </p>
                            </div>
                          </SplideSlide>
                        ))}
                      </Splide>
                    </div>

                    <div>
                      <Splide
                        options={{
                          type: "loop",
                          drag: "free", // keep "free" here for smooth marquee-like effect
                          focus: "center",
                          arrows: false,
                          pagination: false,
                          autoWidth: true,
                          gap: "8px",
                          autoScroll: {
                            speed: -1, // try values between 0.5 - 2 for smoothness
                            pauseOnHover: true,
                            pauseOnFocus: false,
                          },
                        }}
                        extensions={{ AutoScroll }}
                        className="marquee-splide"
                      >
                        {stat.statistics.map((item: any, index: number) => (
                          <SplideSlide key={"statistics-" + index}>
                            <div
                              key={"statistics" + index}
                              className="p-[8px_12px] bg-white border border-[#DBEAB0] flex items-center w-fit"
                            >
                              {item?.image?.data?.attributes?.url && (
                                <Image
                                  src={toWebp(
                                    `${baseUrl}${item?.image?.data?.attributes?.url}`,
                                  )}
                                  alt="flag"
                                  width={16}
                                  height={16}
                                  className="w-[16px] h-[16px] object-cover"
                                />
                              )}
                              <p className="text-[#32343B] text-[12px] ml-[8px]">
                                {item.title}
                              </p>
                            </div>
                          </SplideSlide>
                        ))}
                      </Splide>
                    </div>
                  </div>
                ) : index === 2 ? (
                  <div className="w-full overflow-hidden absolute bottom-[-8px] z-[10]">
                    <div className="mb-[16px]">
                      <Splide
                        options={{
                          type: "loop",
                          drag: "free", // keep "free" here for smooth marquee-like effect
                          focus: "center",
                          arrows: false,
                          pagination: false,
                          autoWidth: true,
                          gap: "8px",
                          autoScroll: {
                            speed: 1, // try values between 0.5 - 2 for smoothness
                            pauseOnHover: true,
                            pauseOnFocus: false,
                          },
                        }}
                        extensions={{ AutoScroll }}
                        className="marquee-splide"
                      >
                        {stat.statistics.map((item: any, index: number) => (
                          <SplideSlide key={"statistics-" + index}>
                            {item?.image?.data?.attributes?.url && (
                              <Image
                                src={toWebp(
                                  `${baseUrl}${item?.image?.data?.attributes?.url}`,
                                )}
                                alt={`statistics-${index}`}
                                width={80 * 2}
                                height={40 * 2}
                                quality={100}
                                className="w-[80px] max-h-[30px] object-contain grayscale"
                              />
                            )}
                          </SplideSlide>
                        ))}
                      </Splide>
                    </div>

                    <div className="mb-[16px]">
                      <Splide
                        options={{
                          type: "loop",
                          drag: "free", // keep "free" here for smooth marquee-like effect
                          focus: "center",
                          arrows: false,
                          pagination: false,
                          autoWidth: true,
                          gap: "8px",
                          autoScroll: {
                            speed: -1, // try values between 0.5 - 2 for smoothness
                            pauseOnHover: true,
                            pauseOnFocus: false,
                          },
                        }}
                        extensions={{ AutoScroll }}
                        className="marquee-splide"
                      >
                        {stat.statistics.map((item: any, index: number) => (
                          <SplideSlide key={"statistics-" + index}>
                            {item?.image?.data?.attributes?.url && (
                              <Image
                                src={toWebp(
                                  `${baseUrl}${item?.image?.data?.attributes?.url}`,
                                )}
                                alt={`statistics-${index}`}
                                width={80 * 2}
                                height={40 * 2}
                                quality={100}
                                className="w-[80px] max-h-[30px] object-contain grayscale"
                              />
                            )}
                          </SplideSlide>
                        ))}
                      </Splide>
                    </div>
                    <div className="mb-[16px]">
                      <Splide
                        options={{
                          type: "loop",
                          drag: "free", // keep "free" here for smooth marquee-like effect
                          focus: "center",
                          arrows: false,
                          pagination: false,
                          autoWidth: true,
                          gap: "8px",
                          autoScroll: {
                            speed: 1, // try values between 0.5 - 2 for smoothness
                            pauseOnHover: true,
                            pauseOnFocus: false,
                          },
                        }}
                        extensions={{ AutoScroll }}
                        className="marquee-splide"
                      >
                        {stat.statistics.map((item: any, index: number) => (
                          <SplideSlide key={"statistics-" + index}>
                            {item?.image?.data?.attributes?.url && (
                              <Image
                                src={toWebp(
                                  `${baseUrl}${item?.image?.data?.attributes?.url}`,
                                )}
                                alt={`statistics-${index}`}
                                width={80 * 2}
                                height={40 * 2}
                                quality={100}
                                className="w-[80px] max-h-[30px] object-contain grayscale"
                              />
                            )}
                          </SplideSlide>
                        ))}
                      </Splide>
                    </div>
                  </div>
                ) : (
                  <> </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
export default CareerPlace;
